import $ from 'jquery'

if (document.getElementById('page-confirm')) {
  page()
}

function page() {
  const $files = $('input[type="hidden"][name^="file"]')
  $files.each((index, file_tag) => {
    const $file = $(file_tag)
    const files = $file.val().split(',')
    files.forEach((file) => {
      const paths = file.split('/')
      const name = paths[paths.length - 1]

      $file.before(`<a href="${file}" target="_blank">${name}</a><br>`)
    })
  })
}
